@if (view(); as view) {
    <div class="card mb-3">
        <div
            class="card-title tile-header me-0 d-flex justify-content-between align-items-center"
            style="word-break: break-word">
            <h3 class="ms-3 me-0 pt-2">
                @if (!view.resultView) {
                    {{ view.agent.agentName }}
                } @else {
                    {{ 'consumption-agents_agent-settings' | translate }}
                }
            </h3>
            @if (!view.resultView) {
                <div ngbDropdown placement="bottom-right">
                    <button
                        class="btn btn-link"
                        id="dropdownMeterActions"
                        ngbDropdownToggle
                        style="float: right">
                        <i class="bi bi-three-dots-vertical"></i>
                    </button>
                    <div ngbDropdownMenu>
                        @if (view.agent.reportId != null) {
                            <button
                                ngbDropdownItem
                                (click)="editAgent(view.agent.reportId, view.agent.agentName)">
                                {{ 'common_Edit' | translate }}
                            </button>
                            <button ngbDropdownItem (click)="duplicateAgent(view.agent.reportId)">
                                {{ 'monitoring_duplicate' | translate }}
                            </button>
                        }
                        <button ngbDropdownItem (click)="navigateToResults(view.agent)">
                            {{ 'monitoring_run_agent' | translate }}
                        </button>
                        @if (buildingNo != null && view.agent.reportId !== null) {
                            <button
                                ngbDropdownItem
                                (click)="deleteAgent(view.agent.reportId, view.agent.agentName)">
                                {{
                                    'modals_deleteEmailModal.actions.deleteEmail'
                                        | translate: 'online' : 'systems'
                                }}
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="card-body">
            @if (view.agent.meterCriteriaMismatch) {
                <div class="m-0 text-warning">
                    <i class="bi bi-exclamation-circle-fill"></i>
                    {{ 'consumption-agents_Meter-list-must-be-updated' | translate }}
                </div>
            } @else {
                <div class="m-0 text-success">
                    <i class="bi bi-check-circle-fill"></i>
                    {{ 'common_All_connected_devices_supported' | translate }}
                </div>
            }
            <ul
                class="list-group list-group-flush description-list w-100"
                #collapse="ngbCollapse"
                [(ngbCollapse)]="isCollapsed">
                <li class="list-group-item">
                    <div>{{ 'monitoring_meterType' | translate }}</div>
                    <div>
                        @if (view.agent.meterSettings.meterSuperTypeNo != null) {
                            {{
                                'mappers_meterType.' + view.agent.meterSettings.meterSuperTypeNo
                                    | translate: 'online' : 'common'
                            }}
                        }
                    </div>
                </li>
                <li class="list-group-item">
                    <div>{{ 'monitoring_usageAndUnits' | translate }}</div>
                    <div>{{ view.agent.usageAndUnitsTranslated }}</div>
                </li>
                <li class="list-group-item">
                    <span>{{ 'label_days' | translate: 'online' : 'common' }}</span>
                    <span>{{ view.agent.dayCount }} </span>
                </li>
                <li class="list-group-item">
                    <div class="text-nowrap">{{ 'monitoring_consumptionType' | translate }}</div>
                    <div>{{ view.agent.consumptionToMonitorTranslated }}</div>
                </li>
                <li class="list-group-item">
                    <div>{{ 'monitoring_investigation' | translate }}</div>
                    <div>{{ view.agent.investigation }}</div>
                </li>
                <li class="list-group-item">
                    <span>{{ 'monitoring_schedule' | translate }}</span>
                    <span
                        >{{
                            'reportagent_' + view.agent.schedule
                                | translate: 'online' : 'reportagent'
                        }}
                    </span>
                </li>
                <li class="list-group-item">
                    <div>{{ 'monitoring_recipients' | translate }}</div>
                    <div>
                        @for (recipient of view.agent.recipients; track recipient) {
                            <div>{{ recipient }}</div>
                        }
                    </div>
                </li>
                <li class="list-group-item">
                    <span>{{ 'monitoring_sendBlanks' | translate }}</span>
                    <span>
                        <app-true-false [value]="view.agent.sendBlank"></app-true-false>
                    </span>
                </li>
                <li class="list-group-item">
                    <div>{{ 'monitoring_show-consumption-for-individual-meters' | translate }}</div>
                    <div>
                        <app-true-false
                            [value]="view.agent.showConsumptionForMeters"></app-true-false>
                    </div>
                </li>
            </ul>
            <div class="text-end">
                @if (view.resultView) {
                    <button class="btn btn-link" (click)="toggleCollapse(!isCollapsed())">
                        @if (isCollapsed()) {
                            {{ 'titles_see-more' | translate: 'online' : 'monitoringAlarms' }}
                        } @else {
                            {{ 'titles_see-less' | translate: 'online' : 'monitoringAlarms' }}
                        }
                    </button>
                }
                @if (!view.resultView && view.agent.reportId != null) {
                    <button
                        class="btn btn-outline-primary"
                        (click)="editAgent(view.agent.reportId!, view.agent.agentName)">
                        {{ 'common_Edit' | translate }}
                    </button>
                }
            </div>
        </div>
    </div>
} @else {
    <app-load />
}
